<template>
    <div ref="filterModal" id="filter-modal">
        <div class="filters-content" @click="toggle()">
            <slot />
        </div>
        <div class="filters-dropdown" :class="[align]" v-if="hasSlot('content') && isActive" ref="filterDropdown">
            <div class="filter-dropdown-head">
                <div class="title">{{ $t("visitor.saveSearchFavorite") }}</div>
            </div>
            <div class="filter-dropdown-content">
                <div class="filter-input-group">
                    <div class="title">{{ $t("visitor.filterName") }}</div>
                    <div class="body">
                        <a-input v-model="name" />
                    </div>
                </div>
            </div>
            <div class="filter-dropdown-footer" :class="{ large: !!value }">
                <div v-if="value" class="delete-action">
                    <button class="delete-button" @click="deleteAction">
                        <a-icon type="delete" />
                    </button>
                </div>
                <div class="modal-actions">
                    <button class="cancel-button" @click="isActive = false">{{ $t("message.cancel")}}</button>
                    <button class="save-button" @click="saveAction">{{ $t("message.save")}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SaveFilterModal",
    props: {
        align: {
            type: String,
            default: "bottom",
        },
        active: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data: () => {
        return {
            name: null,
            isActive: false,
        };
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
            if (this.isActive) this.$refs.filtersModal?.focus();
        },
        hasSlot(name) {
            return !!this.$slots[name];
        },
        saveAction() {
            this.isActive = false;
            this.$emit("save", this.name);
        },
        deleteAction() {
            this.isActive = false;
            this.$emit("delete");
        },
    },
    mounted() {
        this.name = this.value;
        document.addEventListener("click", (e) => {
            if (!this.$refs.filterModal?.contains(e.target)) {
                this.isActive = false;
            }
        });
    },
    watch: {
        active() {
            if (this.active !== this.isActive) {
                this.isActive = !!this.active;
            }
        },
        isActive(newVal) {
            if (this.active !== this.isActive) {
                this.$emit("changeActive", newVal);
            }
        },
        value() {
            if (this.value !== this.name) {
                this.name = this.value;
            }
        },
    },
};
</script>
<style lang="scss">
#filter-modal {
    position: relative;
    user-select: none;
    display: block;

    span {
        display: block;
    }

    .filter-dropdown-back {
        .material-icons {
            cursor: pointer;
        }
    }

    .filters-dropdown {
        position: absolute;
        background-color: #ffffff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        z-index: 9999;
        overflow: hidden;
        width: 300px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .filter-dropdown-head {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 16px;
            background: #ffffff;
            width: 100%;
            color: #1e1e2d;
            border-bottom: 1px solid #f0f0f0;
            
            .title {
                font-size: 14px;
                font-weight: 600;
            }
        }

        &.bottom {
            top: calc(100% + 4px);
        }

        &.top {
            bottom: calc(100% + 4px);
        }

        .filters-head {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #1e1e2d !important;
            padding: 4px 15px;
            border-radius: 5px 5px 0px 0px;
            color: var(--default-text-color);
            font-weight: bold;
            font-size: 14px;
            width: 100%;
        }

        .filter-dropdown-content {
            display: flex;
            padding: 16px;
            width: 100%;
            color: #1e1e2d;
            
            .filter-input-group {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                width: 100%;

                .title {
                    font-size: 13px;
                    font-weight: 500;
                    color: #1e1e2d;
                }

                .body {
                    width: 100%;
                }
            }
        }

        .filter-dropdown-footer {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            align-items: center;
            width: 100%;
            border-top: 1px solid #f0f0f0;
            padding: 12px 16px;
            background: #ffffff;

            &.large {
                justify-content: space-between;
            }

            .delete-action {
                .delete-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    padding: 0;
                    border: 1px solid #ff4d4f;
                    border-radius: 6px;
                    background: #ffffff;
                    color: #ff4d4f;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background: #ff4d4f;
                        color: #ffffff;
                    }

                    .anticon {
                        font-size: 16px;
                    }
                }
            }

            .modal-actions {
                display: flex;
                align-items: center;
                gap: 8px;

                .cancel-button {
                    padding: 6px 16px;
                    border: 1px solid #e8e8e8;
                    border-radius: 6px;
                    background: #ffffff;
                    color: #1e1e2d;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background: #f5f5f5;
                        border-color: #d9d9d9;
                    }
                }

                .save-button {
                    padding: 6px 16px;
                    border: 1px solid #5625CC;
                    border-radius: 6px;
                    background: #5625CC;
                    color: #ffffff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background: #4a1fb3;
                        border-color: #4a1fb3;
                    }
                }
            }
        }
    }
}
</style>
